import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Converter from './pages/Converter';

function App() {
  return (
      <Router>
        <div className="min-h-screen bg-gray-100">
          <Routes>
            <Route path="/en/image-converter" element={<Home />} />
            <Route path="/en/image-converter/:from/:to" element={<Converter />} />

            <Route 
              path="/" 
              element={<Navigate to="/en/image-converter" replace />} 
            />

            <Route 
              path="/en" 
              element={<Navigate to="/en/image-converter" replace />} 
            />

            {/* <Route path="/" element={<Home />} /> */}

          </Routes>
        </div>
      </Router>
  );
}

export default App;
